import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, inject } from 'vue'
import tripModificationStore from '@/store/modules/tripModification'
import { TripModificationPaymentUpdate } from '@/models/dto'
import { currencyFilter } from '@/utils/string'
import { DateTime } from 'luxon'

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'TripModificationPayment',
  props: {
    showTitles: { type: Boolean }
  },
  setup(__props: any) {



// Provide/inject
const removePadding = inject('removePadding')

// Store state
const paymentUpdate = computed<TripModificationPaymentUpdate | undefined>(() => tripModificationStore.paymentUpdate)

const priceDifferencePositive = computed(() => paymentUpdate.value?.priceDifference > 0)
const priceDifferenceNegative = computed(() => paymentUpdate.value?.priceDifference < 0)
const refundPositive = computed(() => paymentUpdate.value?.refund > 0)
const hasRemainingBalanceDueDate = computed(() => !!paymentUpdate.value?.remainingBalanceDueDate)

function formatDueDate(timestamp: string): string {
  return DateTime.fromISO(timestamp).toFormat("MMM d, yyyy")
}

const formattedDueDate = computed(() =>
  paymentUpdate.value?.remainingBalanceDueDate
    ? formatDueDate(paymentUpdate.value.remainingBalanceDueDate)
    : ''
)

onMounted(() => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  })
})

return { __sfc: true,removePadding, paymentUpdate, priceDifferencePositive, priceDifferenceNegative, refundPositive, hasRemainingBalanceDueDate, formatDueDate, formattedDueDate, currencyFilter }
}

})